module.exports = __webpack_public_path__ + "img/hud_left_btm_corn.6cc0b0ed.png";